<div class="mixing">
  <div class="header small">
    <div class="inside">
      <div id="logo"><a href="index.html" title="Startseite"><img ngSrc="./assets/logo.jpg" alt="DRIVOSOL® Tuner"
                                                                  height="225" width="553"></a></div>
      <div class="cat-icon"><svg class="icon"><use xlink:href="#icon-mixing"></use></svg></div>
      <div id="evonik_logo"><img ngSrc="./assets/evonik_logo.png" alt="Evonik" height="76" width="294"></div>
      <div id="change_product" class="select-wrapper">
        @if (selectedMixtureOption === undefined) {
          <div class="select" i18n="@@select_label">Produkt wählen</div>
        }
        @if (selectedMixtureOption !== undefined) {
          <div class="select">{{ selectedMixtureOption.label }}</div>
        }
        <select name="mixtures_products" id="mixtures_products" (change)="selectMixtureOption($event)">
          <option [value]="undefined" i18n="@@select_label">Produkt wählen</option>
          @for (mixtureOption of mixtureOptions; track mixtureOption) {
            <option [value]="mixtureOption.value">{{ mixtureOption.label }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="section mixingbox">
    <div class="inside">
      <div class="cols">
        <div class="col-33">
          <div class="milkybox">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 27px">
              <h2 i18n="@@mixing_propane" style="margin-bottom: 0">Propan  </h2><span i18n="@@mixing_weight_fraction" class="mass_fraction">Masseanteil</span>
            </div>
            <app-slider-with-number #propaneInput (change)="onChangeValue($event, 'propane')"></app-slider-with-number>
          </div>
        </div>
        <div class="col-33">
          <div class="milkybox">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 27px">
              <h2 i18n="@@mixing_iso_butane" style="margin-bottom: 0">Iso-butan </h2><span i18n="@@mixing_weight_fraction" class="mass_fraction">Masseanteil</span>
            </div>
            <app-slider-with-number #isoButaneInput (change)="onChangeValue($event, 'isoButane')"></app-slider-with-number>
          </div>
        </div>
        <div class="col-33">
          <div class="milkybox">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 27px">
              <h2 i18n="@@mixing_n_butane" style="margin-bottom: 0">N-Butan  </h2><span i18n="@@mixing_weight_fraction" class="mass_fraction">Masseanteil</span>
            </div>
            <app-slider-with-number #nButaneInput (change)="onChangeValue($event, 'nButane')"></app-slider-with-number>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section pressureresultbox">
    <div class="inside">
      <div class="cols">
        <div class="col-33">
          <div class="milkybox mixing-result-percent">
            <span i18n="@@mixing_total">Gesamt</span>
            <div class="resultbox">
              @if ((total > 0 && total < 100) || total > 100) {
                <svg class="icon" style="display: inline-block"><use xlink:href="#icon-warning"></use></svg>
              }
              <span class="total-value">{{ total | number: '1.0-2': 'de-DE' }}</span> %</div>
            </div>
          </div>

          <div class="col-66">
            <div class="milkybox pressure-result">
              <div class="cols">
                <div class="col-50">
                  <div class="boxed">
                    <span i18n="@@mixing_caculate">Errechneter Druck (BAR)</span>
                  </div>
                </div>
                <div class="col-50">
                  <div class="boxed">
                    @if (form.value.pressure === null) {
                      <input class="milky result-mixing_pressure" type="text" value="0,0" readonly="">
                    } @else {
                      <input class="milky result-mixing_pressure" type="text" [value]="form.value.pressure | number: '1.0-2': 'de-DE'" readonly="">
                    }


                  <a (click)="openMail()" class="button mail-btn btn-icon custom" title="Diese individuelle Mischung können sie
  gerne bei uns anfragen."><svg class="icon"><use xlink:href="#icon-mail"></use></svg></a>
                      <a title="Druck" class="button pressure-btn btn-icon" (click)="openPressure()"><svg class="icon"><use xlink:href="#icon-pressure"></use></svg></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (matchingProducts.length > 0 && isHundredPercent()) {
        <app-product-table [products]="matchingProducts" mode="mixing" i18n="@@products">PRODUCTS</app-product-table>
      }
      @if (similarProducts.length > 0 && isHundredPercent()) {
        <app-product-table [products]="similarProducts" mode="mixing" i18n="@@similar_products">PRODUCTS WITH SIMILAR PRESSURE</app-product-table>
      }

    </div>
